unable to read source [project]/repos/src/scraping/parameters/options.ts